// extracted by mini-css-extract-plugin
export var body = "_c7-0";
export var sectionHeader = "_c7-4";
export var shortcutColumns = "_c7-2";
export var shortcutList = "_c7-1";
export var shortcutSection = "_c7-3";